module.exports = __webpack_public_path__ + "static/img/attachment_placeholder.2f5c67cc.png";